import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Grid } from 'swiper/modules';

export default function equipePedagoSlider() {
  const swiperContainer = document.querySelector('.equipe-pedago__slider.swiper') as HTMLElement;
  const prevEl = swiperContainer?.querySelector('.swiper-button-prev') as HTMLElement;
  const nextEl = swiperContainer?.querySelector('.swiper-button-next') as HTMLElement;
  const pagination = swiperContainer?.querySelector('.swiper-pagination') as HTMLElement;
  const scrollbar = swiperContainer?.querySelector('.swiper-scrollbar') as HTMLElement;

  swiperContainer && new Swiper(swiperContainer, {
    modules: [Grid, Navigation, Pagination, Scrollbar],
    slidesPerView: 2,
    spaceBetween: 10,
    grid: {
      fill: 'row',
      rows: 2
    },
    navigation: {
      prevEl,
      nextEl
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
    pagination: {
      el: pagination,
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 16,
        grid: {
          fill: 'column',
          rows: 1,
        }
      },
      1024: {
        spaceBetween: 24,
        slidesPerView: 4,
        grid: {
          fill: 'column',
          rows: 1,
        }
      }
    }
  })

}